document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector("[data-help-center]");
  if (!root) return;

  const views = Array.from(root.querySelectorAll("[data-view]"));
  const searchInput = root.querySelector("#helpCenterSearchInput");
  const header = root.querySelector(".help-center__header");

  let activeView = "home";
  let searchQuery = "";
  let prevView = "home";
  let prevScrollY = 0;

  const getActiveViewEl = () =>
    root.querySelector(`[data-view="${CSS.escape(activeView)}"]`);

  const ensureDetailView = () => {
    let detail = root.querySelector('[data-view="detail"]');
    if (detail) return detail;

    detail = document.createElement("section");
    detail.setAttribute("data-view", "detail");
    detail.className = "help-center__view help-center__detail page-width";

    detail.innerHTML = `
      <div class="help-center__detail-header">
        <h1 class="help-center__detail-title" data-detail-title></h1>
        <button type="button" class="help-center__detail-back" data-back-prev>BACK TO CUSTOMER SERVICE</button>
      </div>
      <div class="help-center__detail-body" data-detail-content></div>
    `;

    root.appendChild(detail);
    views.push(detail);
    return detail;
  };

  const setHeaderVisibility = () => {
    if (!header) return;
    header.classList.toggle("is-hidden", activeView !== "home");
  };

  const clearSearchState = () => {
    const viewEl = getActiveViewEl();
    if (!viewEl || activeView === "home" || activeView === "detail") return;

    const content = root.querySelector(".help-center__content");
    if (content) content.classList.remove("has-found-values", "has-search-query");

    viewEl.querySelectorAll("[data-search-item]").forEach((item) => item.classList.remove("active"));
    viewEl.querySelectorAll(".help-center__subhead").forEach((t) => t.classList.remove("active"));

    const noResults = viewEl.querySelector("[data-no-results]");
    if (noResults) noResults.hidden = true;
  };

  const setView = (name) => {
    activeView = name;

    views.forEach((v) => v.classList.toggle("is-active", v.dataset.view === name));

    if (searchInput) searchInput.value = "";
    searchQuery = "";
    clearSearchState();
    setHeaderVisibility();
  };

  const openDetailFromItem = (item) => {
    const titleEl = item.querySelector(".help-center__q-text");
    const bodyEl = item.querySelector(".help-center__a-inner");
    if (!titleEl || !bodyEl) return;

    const detail = ensureDetailView();
    const detailTitle = detail.querySelector("[data-detail-title]");
    const detailContent = detail.querySelector("[data-detail-content]");

    if (detailTitle) detailTitle.textContent = titleEl.textContent.trim();
    if (detailContent) detailContent.innerHTML = bodyEl.innerHTML;

    prevScrollY = window.scrollY || 0;
    prevView = activeView;

    setView("detail");
    window.scrollTo(0, 0);
  };

  const handleSearchQuery = () => {
    const viewEl = getActiveViewEl();
    if (!viewEl || activeView === "home" || activeView === "detail") return;

    const content = root.querySelector(".help-center__content");
    const qEls = [...viewEl.querySelectorAll(".help-center__q-text")];

    viewEl.querySelectorAll("[data-search-item]").forEach((item) => item.classList.remove("active"));
    viewEl.querySelectorAll(".help-center__subhead").forEach((t) => t.classList.remove("active"));

    if (!searchQuery) {
      if (content) content.classList.remove("has-found-values", "has-search-query");
      const noResults = viewEl.querySelector("[data-no-results]");
      if (noResults) noResults.hidden = true;
      return;
    }

    let foundValues = false;

    qEls.forEach((el) => {
      const text = el.innerText.toLowerCase().trim();
      const item = el.closest(".help-center__item");
      if (!item) return;

      if (text.includes(searchQuery)) {
        foundValues = true;

        const prev = item.previousElementSibling;
        if (prev && prev.classList.contains("help-center__subhead")) prev.classList.add("active");

        item.classList.add("active");
      }
    });

    if (content) content.classList.add("has-search-query");
    if (content) content.classList[foundValues ? "add" : "remove"]("has-found-values");

    const noResults = viewEl.querySelector("[data-no-results]");
    if (noResults) noResults.hidden = foundValues;
  };

  root.addEventListener("click", (e) => {
    const openBtn = e.target.closest("[data-open-category]");
    if (openBtn) {
      setView(openBtn.dataset.openCategory);
      return;
    }

    const backHomeBtn = e.target.closest("[data-back-home]");
    if (backHomeBtn) {
      setView("home");
      return;
    }

    const backPrevBtn = e.target.closest("[data-back-prev]");
    if (backPrevBtn) {
      setView(prevView || "home");
      window.scrollTo(0, prevScrollY || 0);
      return;
    }

    const qBtn = e.target.closest('[data-toggle-answer], .help-center__q');
    if (!qBtn) return;

    const viewEl = getActiveViewEl();
    if (!viewEl || activeView === "home" || activeView === "detail") return;

    const item = qBtn.closest(".help-center__item");
    if (!item) return;

    openDetailFromItem(item);
  });

  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      searchQuery = e.target.value.toLowerCase().trim();
      handleSearchQuery();
    });
  }

  ensureDetailView();
  setView("home");
});
